import { combineReducers, Reducer, AnyAction } from 'redux';
import ApplicationReducer, {
  IApplicationState,
} from '../screens/Application/reducers/ApplicationReducer';
import { HomeReducer, IHomeState } from '../screens/Home/reducer/HomeReducer';
import ProfileReducer, { IProfileState } from '../screens/Profile/reducers/ProfileReducer';

export interface IState {
  readonly application: IApplicationState;
  readonly profile: IProfileState;
  readonly home: IHomeState;
}

const RootReducer: Reducer<IState, AnyAction> = combineReducers({
  application: ApplicationReducer,
  home: HomeReducer,
  profile: ProfileReducer,
});

export default RootReducer;
